// extracted by mini-css-extract-plugin
export default {"label":"UserAvatar_label__rrn6b"};